<template>
	<div class="container">
		<div class="row clearfix">
			<div class="column full">
				<h3
					class="iv2-contact-form__title"
					style="text-align: left;"
				>{{ contact.header_contents.catch_copy_main }}</h3>
			</div>
		</div>
		<div class="row clearfix">
			<div class="column full">
				<p
					class="iv2-contact-form__sumally"
					v-html="contact.header_contents.lead_line"
					style="text-align: left; letter-spacing: 3px;"
				></p>
			</div>
		</div>
		<div class="row clearfix">
			<div class="column full" data-noedit>
				<div class="spacer height-20"></div>
			</div>
		</div>
		<div class="row clearfix" style="padding: 0px;" draggable="false">
			<form @submit.prevent="submit">
				<loading
					:active.sync="isLoading"
					:can-cancel="false"
					:on-cancel="onCancel"
					:is-full-page="fullPage"
					:background-color="bgColor"
				></loading>
				<div v-if="success" v-html="send_text" class="iv2-contact-form__response-text"></div>
				<div v-else-if="timeout" v-html="send_error" class="iv2-contact-form__response-text"></div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">必須</span>
						<span>お名前</span>
					</label>
					<input
						type="text"
						class="w-75 p-2"
						name="name"
						id="name"
						v-model="fields.name"
						style="border: 1px solid #8c8c8c;"
						placeholder="お名前"
					/>
					<div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">必須</span>
						<span>電話番号</span>
					</label>
					<input
						type="tel"
						class="w-75 p-2"
						name="tel"
						id="tel"
						v-model="fields.tel"
						style="border: 1px solid #8c8c8c;"
						placeholder="電話番号"
					/>
					<div v-if="errors && errors.tel" class="text-danger">{{ errors.tel[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">必須</span>
						<span>メールアドレス</span>
					</label>
					<input
						type="email"
						class="w-75 p-2"
						name="email"
						id="email"
						v-model="fields.email"
						style="border: 1px solid #8c8c8c;"
						placeholder="メールアドレス"
					/>
					<div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">必須</span>
						<span>お問い合わせ内容</span>
					</label>
					<textarea
						class="w-100 p-2"
						id="message"
						name="message"
						rows="5"
						v-model="fields.message"
						style="border: 1px solid #8c8c8c;"
					></textarea>
					<div v-if="errors && errors.message" class="text-danger">{{ errors.message[0] }}</div>
				</div>
				<div class="column full">
					<p class="text-center mb-4">
						お客様の個人情報は、個人情報に関して適用される法令規範を遵守するとともに、
						<br />お問い合わせ内容や貴重なご意見は今後の業務の改善並びに参考とさせていただきます。
					</p>
					<p class="text-center mb-0">
						<router-link to="/privacypolicy" class="iv2-contact__privacy-link">プライバシーポリシー</router-link>をご一読ください。
					</p>
					<div class="text-center">
						<label style="cursor: pointer;">
							<input type="checkbox" name="agreement" id="agreement" v-model="fields.agreement" />プライバシーポリシーに同意します。
							<div v-if="errors && errors.agreement" class="text-danger">{{ errors.agreement[0] }}</div>
						</label>
					</div>
					<p class="text-center mt-5">
						<input class="iv2-contact-form__btn theme__main-btn" type="submit" value="入力内容を確認" />
					</p>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	components: {
		Loading,
	},

	props: ["contact"],

	data() {
		return {
			send_text:
				"お問い合わせいただきありがとうございます。<br />メールの送信が完了いたしました。<br /><br />内容を確認の上ご連絡をいたしますので、お待ちください。",
			send_error:
				"フォームが送信できませんでした。<br /><br />恐れ入りますが、お時間をおいて再度ご入力の上、送信をお試しください。<br />ご不便おかけして申し訳ございません。",

			fields: {},
			errors: {},
			success: false,
			timeout: false,
			loaded: true,
			fullPage: true,
			isLoading: false,
			bgColor: "#525252",
		};
	},

	methods: {
		submit() {
			this.isLoading = true;

			setTimeout(() => {
				this.loaded = true;
				if (this.isLoading === true) {
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
					this.timeout = true;
					this.isLoading = false;
					// console.log("loading timeout");
				}
			}, 30000);

			if (this.loaded) {
				this.loaded = false;
				this.success = false;
				this.timeout = false;
				this.errors = {};

				this.axios
					.post(
						process.env.VUE_APP_SEND_URL +
							process.env.VUE_APP_END_POINT +
							process.env.VUE_APP_ID,
						this.fields,
						{
							withCredentials: true,
						}
					)

					.then((response) => {
						this.fields = {}; //Clear input fields.
						this.loaded = true;
						this.success = true;
						this.isLoading = false;
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						});
						console.log(response);
					})
					.catch((error) => {
						this.loaded = true;
						if (error.response.status === 422) {
							this.errors = error.response.data.errors || {};
						}
						this.isLoading = false;
					});
			}
		},
		onCancel() {
			// console.log("User cancelled the loader.");
		},
	},
};
</script>

<style lang="scss">
.iv2-contact-form__response-text {
	background-color: #ddd;
	color: #000;
	margin: 1rem 0;
	padding: 0.75rem 1.25rem;
	border-radius: 5px;
}

.iv2-contact-form__btn {
	text-align: center;
	display: inline-block;
	border: 0;
	border-radius: 50px;
	font-size: 18px;
	letter-spacing: 2px;
	padding-top: 15px;
	padding-bottom: 15px;
	border-radius: 0;
	width: 300px;
	max-width: 100%;
}

@media (max-width: 1199px) {
	.iv2-contact__privacy-link {
		text-decoration: underline;
	}
}
</style>
